/**
 * Wize Mobile API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserMobile { 
    id?: string;
    identification?: string;
    description?: string;
    shortDescription?: string;
    languageId?: string;
    externalIdentification?: string;
    email?: string;
    userType?: UserMobile.UserTypeEnum;
    publicEmail?: string;
    publicPhone?: string;
    surmame?: string;
    name?: string;
    domicile?: string;
    authorizedPaymentsAndTransfers?: boolean;
    authorizedStockExchangeOrders?: boolean;
    authorizedScanAndPay?: boolean;
    readonly contacts?: Array<UserMobile>;
    profileIcon?: string;
    remarks?: string;
    thirdPartyTypeId?: string;
    swiftBicCodeId?: string;
    residenceId?: string;
    nationalityId?: string;
    fiscalResidenceId?: string;
    legalEntityIdentifier?: string;
    sessionTimeoutSeconds?: number;
    disableScreenshot?: boolean;
}
export namespace UserMobile {
    export const UserTypeEnum = {
        CLIENT: 'CLIENT',
        EMPLOYEE: 'EMPLOYEE',
        CLIENT_CRM: 'CLIENT_CRM'
    } as const;
    export type UserTypeEnum = typeof UserTypeEnum[keyof typeof UserTypeEnum];
}


